import $ from 'jquery';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import s from '../../services/allservices.jsx';
// import '../../stylesheet/forcechangepassword.css'
import '../../stylesheet/changepassword.css';
import LoaderSmall from "../loader/loadersmall.jsx";
import GuestNav from '../navigation/guestnavbar.jsx';
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js';
import OtpPopup from '../otp/OtpPopup.js';

const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
})

const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    }
})
const JSEncrypt = window.JSEncrypt

class ForceChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            correctPassword: true,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            otpOpen: false,
            otp: "",
            popupLoader: false,
            oldPasswordError: "",
            newPasswordError: "",
            confirmPasswordError: "",
        }
    }

    // onChange = (e, value) => this.setState({ [e.target.name]: e.target.value }, () => {
    // })
    onChange = (e) => {
        const { name, value } = e.target;

        this.setState(
            {
                [name]: value,
            },
            this.validateForm
        );
    };
    validateForm = () => {
        const {
            oldPassword,
            newPassword,
            confirmPassword,
        } = this.state;

        let oldPasswordError = "";
        let newPasswordError = "";
        let confirmPasswordError = "";

        const passwd =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+\-,'#$%^&*])(?=.{8,})/;

        if (!oldPassword.trim()) {
            oldPasswordError = "Current password is required";
        }

        if (!newPassword.trim()) {
            newPasswordError = "New password is required";
        } else if (!passwd.test(newPassword)) {
            newPasswordError =
                "Password must contain uppercase, lowercase, number and special character";
        } else if (
            oldPassword &&
            newPassword &&
            oldPassword === newPassword
        ) {
            newPasswordError =
                "New password must differ from current password";
        }

        if (!confirmPassword.trim()) {
            confirmPasswordError = "Confirm password is required";
        } else if (
            newPassword &&
            confirmPassword &&
            newPassword !== confirmPassword
        ) {
            confirmPasswordError =
                "New password and confirm password must match";
        }

        this.setState({
            oldPasswordError,
            newPasswordError,
            confirmPasswordError,
            correctPassword: passwd.test(newPassword),
        });
    };

    validatePassword(e) {
        e.preventDefault();
        // eslint-disable-next-line
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if ((passwd.test(e.target.value))) {
                this.setState({
                    [e.target.name]: e.target.value,
                    correctPassword: true
                })

            }

            else {
                this.setState({
                    correctPassword: false
                })
            }
        }

    }
    componentDidMount() {
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });

    }
    handleChange = (e, value) => {

        var myInput = document.getElementById("psw");
        var letter = document.getElementById("letter");
        var capital = document.getElementById("capital");
        var number = document.getElementById("number");
        var length = document.getElementById("length");
        var spec = document.getElementById("sp");

        // // When the user clicks on the password field, show the message box
        myInput.onfocus = function () {
            document.getElementById("errmessagebody").style.display = "block";
        }
        // When the user clicks outside of the password field, hide the message box
        myInput.onblur = function () {
            document.getElementById("errmessagebody").style.display = "none";
        }
        myInput.onkeyup = function () {
            // Validate lowercase letters
            var lowerCaseLetters = /[a-z]/g;
            if (myInput.value.match(lowerCaseLetters)) {
                letter.classList.remove("invalid");
                letter.classList.add("valid");
            } else {
                letter.classList.remove("valid");
                letter.classList.add("invalid");
            }

            // Validate capital letters
            var upperCaseLetters = /[A-Z]/g;
            if (myInput.value.match(upperCaseLetters)) {
                capital.classList.remove("invalid");
                capital.classList.add("valid");
            } else {
                capital.classList.remove("valid");
                capital.classList.add("invalid");
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if (myInput.value.match(numbers)) {
                number.classList.remove("invalid");
                number.classList.add("valid");
            } else {
                number.classList.remove("valid");
                number.classList.add("invalid");
            }

            // Validate length
            if (myInput.value.length >= 8) {
                length.classList.remove("invalid");
                length.classList.add("valid");
            } else {
                length.classList.remove("valid");
                length.classList.add("invalid");
            }

            //special character match
            // eslint-disable-next-line
            var spe = /(?=.*[!@.+-,'#\$%\^&\*])/g;
            if (myInput.value.match(spe)) {
                spec.classList.remove("invalid");
                spec.classList.add("valid");
            } else {
                spec.classList.remove("valid");
                spec.classList.add("invalid");
            }
        }
        // eslint-disable-next-line
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if ((passwd.test(e.target.value))) {
                this.setState({
                    [e.target.name]: e.target.value,
                    correctPassword: true
                })

            }

            else {
                this.setState({
                    correctPassword: false
                })
            }
        }


    }


    otpPopupOpenModal = () => {
        const {
            oldPassword,
            newPassword,
            confirmPassword,
            correctPassword
        } = this.state;

        if (correctPassword === false) {
            toast.error('Please check password format', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        if (oldPassword === "" || newPassword === "" || confirmPassword === "") {
            toast.error('Please Enter Data In Required Fields', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error('New Password And Confirm Password Should Be Same', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        if (oldPassword === newPassword) {
            toast.error('New Password And old Password Should not Be Same', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        const otpValidation = localStorage.getItem('otpValidation');

        if (otpValidation === 'false') {
            // Skip OTP modal — call final API directly
            this.setState({ otp: "" }, () => {
                this.handleSubmit(null, null);
            });
        } else {
            // Show OTP modal as usual
            this.setState({ otpOpen: true }, () => {
                this.handleRequestOtp(false);
            });
        }
    };

    handleRequestOtp = (isResend = false) => {
        let token = "Token " + localStorage.getItem("token");

        let plink =
            localStorage.getItem("pform") === "AU"
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        let traceId = getClientId();

        let otpUrl = s.otp_change_password;

        if (isResend) {
            otpUrl = `${s.otp_change_password}/true`;
        }

        fetch(plink + otpUrl, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: token,
                "X-Trace-Id": traceId,
                "X-Client-APP": buildClientHeader(),
            })
        })
            .then((response) => {
                if (
                    response.status === 200 ||
                    response.status === 201 ||
                    response.status === 204
                ) {
                    toast.success(response.headers.get("message"), {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
                else if (response.status === 401) {
                    if (this.props.history !== undefined) {
                        this.props.history.push('/sessionout');
                    }
                }
                else {
                    toast.error(response.headers.get("message"), {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            });
    };
    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({
            otp: otp,
            popupLoader: true,
        }, () => {

            this.handleSubmit(onSuccess, onError);

        });

    };
    otpPopupCloseModal = () => {

        this.setState({
            otpOpen: false,
            popupLoader: false,
        });

    };
    handleSubmit1 = () => {
        this.props.history.push('/');
    }

    handleSubmit = (onSuccess, onError) => {
        const { oldPassword, newPassword, confirmPassword } = this.state

        const { publicKey } = this.props
        if (publicKey && publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            let _this = this

            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                confirmPassword: encrypt.encrypt(confirmPassword),
                newPassword: encrypt.encrypt(newPassword),
                oldPassword: encrypt.encrypt(oldPassword),
                accountId: encrypt.encrypt(localStorage.getItem("accountId")),
                otp: this.state.otp
            }
            this.setState({
                loader: true
            })
            let token = "Token " + localStorage.getItem('token')
            if (oldPassword !== '' && newPassword !== '' && confirmPassword !== '') {
                if (newPassword === confirmPassword) {
                    let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                    let traceId = getClientId();
                    fetch(plink + s.change_password, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': token,
                            'X-Trace-Id': traceId,
                            'X-Client-APP': buildClientHeader(),
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                                // this.setState({
                                //     loader: false
                                // })
                                // setTimeout(function () {
                                //     _this.props.history.push('/home');
                                // }, 3000);
                                if (onSuccess) {
                                    onSuccess();
                                }

                                this.setState({
                                    popupLoader: false,
                                    loader: true
                                }, () => {

                                    setTimeout(() => {

                                        this.setState({
                                            loader: false
                                        });

                                        _this.props.history.push('/home');

                                    }, 3000);

                                });
                            }
                            else if (response.status === 401) {

                                this.setState({
                                    popupLoader: false,
                                    loader: false
                                });

                                if (this.props.history !== undefined) {
                                    this.props.history.push('/sessionout')
                                }

                            }
                            else if (response.status === 422) {

                                this.setState({
                                    popupLoader: false,
                                    loader: false,
                                });
                                if (onError) {
                                    onError(response.headers.get('message'));
                                }
                                let message = response.headers.get("message");

                                response.json()
                                    .then((json) => {
                                        if (json && json.message) {
                                            message = json.message;
                                        }
                                        toast.error(message, {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            draggablePercent: 60,
                                        });
                                    })
                                    .catch(() => {
                                        toast.error(message, {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            draggablePercent: 60,
                                        });
                                    });

                            }
                            else {
                                this.setState({
                                    popupLoader: false,
                                    loader: false
                                });

                                if (onError) {
                                    onError(response.headers.get('message'));
                                }
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                                this.setState({
                                    loader: false
                                })
                                // setTimeout(function () { window.location.reload(true); }, 2000);

                            }
                        })
                } else {
                    // eslint-disable-next-line 
                    toast.error('New Password And Confirm Password Should Be Same'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };
                    this.setState({
                        loader: false
                    })
                }
            } else {
                // eslint-disable-next-line 
                toast.error('Please Enter Data In Required Fields'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                };
                this.setState({
                    loader: false
                })
            }

        }
    }

    render() {
        const { correctPassword } = this.state
        const height = $(window).height() - 108;
        const isFormValid =
            this.state.oldPassword &&
            this.state.newPassword &&
            this.state.confirmPassword &&
            !this.state.oldPasswordError &&
            !this.state.newPasswordError &&
            !this.state.confirmPasswordError;
        return (
            <div className="col-md-12 forcechangepwd" style={{ minHeight: height }}>
                <GuestNav />
                {this.state.otpOpen && (
                    <OtpPopup
                        open={this.state.otpOpen}
                        onClose={this.otpPopupCloseModal}
                        handleRequestOtp={this.handleRequestOtp}
                        onSubmit={this.handleOtpSubmit}
                        loading={this.state.popupLoader}
                    />
                )}
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                    style={{ zIndex: 999999 }}
                />
                <div className="row">
                    <div className="col-md-4" >
                        <div id="errmessagebody" style={{ marginTop: "80px", marginLeft: "10px" }} >
                            <span style={{ fontSize: "14px", marginLeft: "10px" }}> Password must contain following:</span><br />
                            <div style={{ marginTop: "8px", padding: "0px 15px" }}>
                                <span id="length" className="invalid">At least 8 to 15 characters </span><br />
                                <span id="capital" className="invalid">At least one upper case alphabet</span><br />
                                <span id="letter" className="invalid">At least one lower case alphabet</span><br />
                                <span id="sp" className="invalid">At least one special character ( ! @ # $ % ^ & * )</span><br />
                                <span id="number" className="invalid">At least one number</span><br />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" >
                        <div className="" style={{ marginTop: "80px" }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="summary-header">
                                        <div className="row">
                                            <div className="col-md-6 ml-0 pl-0" style={{ fontSize: 18 + "px !important" }}>
                                                <h4 className='logmainheading mainheading'>Change Password</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-11 col-sm-12">
                                    <div className="row input-group">
                                        <div className="col-sm-9">
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="Current Password"
                                                type="password"
                                                id="currentPassword"
                                                maxLength="15"
                                                name="oldPassword"
                                                autoComplete="none"
                                                className="input-width required"
                                                onChange={this.onChange}
                                                errorText={this.state.oldPasswordError}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />

                                            <span
                                                toggle="#currentPassword"
                                                className="col-sm-1 fa fa-fw fa-eye-slash field-icon toggle-password"
                                                style={{
                                                    top: "35px",
                                                    right: "16px",
                                                    position: "absolute",
                                                    color: "#333"
                                                }}
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-11 col-sm-12">
                                    <div className="row input-group" >

                                        <div className="col-sm-9" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="New Password"
                                                type="password"
                                                id="psw"
                                                maxLength="15"
                                                name="newPassword"
                                                autoComplete='none'
                                                className="input-width required"
                                                onFocus={this.handleChange.bind(this)}
                                                // onChange={this.handleChange.bind(this)}
                                                onChange={(e) => {
                                                    this.handleChange(e);
                                                    this.onChange(e);
                                                }}
                                                onBlur={this.validatePassword.bind(this)}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={correctPassword ? null : "Please Check Help Button."}
                                                errorText={this.state.newPasswordError}
                                            />
                                            <span toggle="#psw" className=" col-sm-1 fa fa-fw fa-eye-slash field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div>
                                        <div className="col-sm-9 tooltip" style={{ top: "10px", textAlign: "right" }}>
                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                            <span className="tooltiptext" style={{ fontSize: "12px", maxWidth: "260px" }} >Your Password must contain at least 8 character, one number, one lowercase ,special character and one uppercase letter </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-11">
                                    <div className="row input-group" >

                                        <div className="col-sm-9" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="Confirm Password"
                                                type="password"
                                                id="loginpassword"
                                                maxLength="15"
                                                name="confirmPassword"
                                                autoComplete='none'
                                                className="input-width required"
                                                style={{ zIndex: "0" }}
                                                // onChange={this.onChange}
                                                onChange={this.onChange}
                                                errorText={this.state.confirmPasswordError}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                            <span toggle="#loginpassword" className="col-sm-1 fa fa-fw fa-eye-slash field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="offset-sm-2 col-sm-12 col-md-12 " >
                                            <RaisedButton
                                                label="Change"
                                                disabled={!isFormValid}
                                                className="btn-std mr-2"
                                                // style={styles.button}

                                                backgroundColor="#FFCE39"
                                                labelColor="#115876"
                                                // onClick={this.handleSubmit.bind(this)}
                                                onClick={this.otpPopupOpenModal}
                                                style={{ marginTop: "10px" }}
                                            />

                                            <RaisedButton
                                                label="Cancel"
                                                className=" btn-std mr-2"
                                                // style={styles.button}
                                                backgroundColor="#333"
                                                labelColor="#fff"
                                                onClick={this.handleSubmit1.bind(this)}
                                                style={{ marginTop: "10px", marginRight: "3px" }}
                                            />
                                        </div>


                                        {this.state.loader === true &&
                                            <div className="col-sm-1" style={{ marginTop: "-17px", width: "30% !mportant" }} >
                                                <LoaderSmall />
                                            </div>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForceChangePassword));   


// WEBPACK FOOTER //
// ./src/components/forcechangepassword/forcechangepassword.jsx